import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Style } from '@local/client-contracts';
import { Visit } from '@local/common-web';

@Component({
  selector: 'visit-item',
  templateUrl: './visit-item.component.html',
  styleUrls: ['./visit-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VisitItemComponent {
  get model(): Visit {
    return this._model;
  }
  @Input()
  set model(value: Visit) {
    this._model = value;
    this.icon = { type: 'img', value: this._model.site.icon };
  }
  @Input() selected: boolean;
  @Input() set query(value: string) {
    if (!value) return;
    this.setQuery(value);
  }
  get query() {
    return this._query;
  }
  icon: Style.EntityIcon<Style.EntityIconType>;
  highlights: Array<string> = [];

  private _query: string;
  private _model: Visit;

  private setQuery(newQuery: string): void {
    if (this.highlights?.includes(this.query)) {
      this.highlights.splice(this.highlights.indexOf(this.query), 1);
    }
    if (newQuery) {
      this.highlights = [...(this.highlights ?? []), newQuery.trim()];
    }
    this._query = newQuery;
  }
}
